import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostUnlinkOrganizationRequest = {
	organizationId: number;
};

export const postUnlinkOrganization = createPostEndpoint<PostUnlinkOrganizationRequest>(
	'/api/v3/core/organizations/unlink',
	{
		skipAuthRefresh: true
	}
);
